import * as React from 'react';
export const pledgeSvg = React.forwardRef(function pledgeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.95 28H5V4h13.882c2.506 0 4.848 1.012 6.595 2.848C27.08 8.534 28 10.723 28 12.855c0 2.131-.919 4.329-2.52 6.024-1.498 1.585-3.431 2.56-5.53 2.808V28ZM7.134 25.918h10.68v-4.169h-6.367V10.251h8.501v9.322c2.98-.519 5.915-3.134 5.915-6.718 0-3.204-2.867-6.773-6.982-6.773H7.135v19.836Zm6.447-6.251h4.232v-7.334h-4.232v7.334Z',
      fill: '#000',
    }),
  );
});
pledgeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pledge = {
  category: 'brand',
  colorable: false,
  name: 'pledge',
  svg: pledgeSvg,
};
